/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workOrderActions from 'actions/workOrderActions';
import * as justAskActions from 'actions/justAskActions';
import * as siteActions from 'actions/siteActions';
import * as sqcActions from 'actions/sqcActions';
import * as chargeActions from 'actions/chargeActions';
import CloseSteps from 'workOrderComponents/close/CloseSteps';
import WorkOrderHeader from 'workOrderComponents/WorkOrderHeader';
import { Link } from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import Footer from 'containers/Footer';
import FontIcon from 'material-ui/FontIcon';
import JustAskSummary from 'justAskComponents/JustAskSummary';
import { withRouter } from 'react-router';
import Loading from 'layoutComponents/Loading';
import { isInProgressState, isFinalState, isClosingOrderState, isFailedState } from 'utils/orderStatusUtils';
import * as mouseFlowUtils from '../../utils/mouseFlowUtils';
import { TAG_CLOSE_ORDER_PAGE } from '../../constants/mouseFlow';
import { isSkinnyInstallType } from "../../utils/helper";



export class CloseOrderPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.jumpToCharges = this
            .jumpToCharges
            .bind(this);

        this.jumpToJustAsk = this
            .jumpToJustAsk
            .bind(this);

        mouseFlowUtils.setTag(TAG_CLOSE_ORDER_PAGE);
    }

    componentWillMount() {
        const { workOrderActions, match, workOrder } = this.props;

        if (workOrder) {
            const orderDetail = workOrder.getIn(['workOrderDetails', match.params.workOrderId]);
            const serviceTypeId = orderDetail.getIn(['schedulingSystemDetails', 'details', 'serviceOrderInfoV2', 'serviceTypeId']);

            if (isSkinnyInstallType(serviceTypeId)) {
                const customerId = orderDetail.getIn(['customerDetails', 'details', 'accountNumber']);
                const techId = orderDetail.getIn(['schedulingSystemDetails', 'details', 'technicianId']);
                const billingSystem = orderDetail.getIn(['schedulingSystemDetails', 'details', 'billingSystem']);
                const houseNumber = orderDetail.getIn(['schedulingSystemDetails', 'details', 'addressInfo', 'addressId']);
                const equipmentDetails = orderDetail.getIn(['equipmentDetails', 'details']);
                let macAddress = null;

                if (equipmentDetails) {
                    const hsdOutlet = equipmentDetails.toJS().find(outlet => outlet.requiredPortType.some(port => port === 'HSD'));
                    if (hsdOutlet) {
                        macAddress = hsdOutlet.macAddress;
                    }
                }

                workOrderActions.initDeliveryProof({
                    techId: techId,
                    customerId: customerId,
                    billingSystem: billingSystem,
                    macAddresses: [macAddress],
                    houseNumber: houseNumber,
                    deliveryProofAddMemoRequest: {
                        deliveryProofBypassFlag: false,
                        deliveryProofDescription: ""
                    }
                }, match.params.workOrderId);
            }

            const marketId = orderDetail.getIn([
                'networkDetails',
                'details',
                'marketID'
            ]);

            workOrderActions.getDigitalChannelsStarted(marketId, match.params.workOrderId);
        }

        workOrderActions.workOrderDetailPageOpened(match.params.workOrderId);
    }

    jumpToCharges(e) {
        e.preventDefault();
        const { workOrderActions, history, match } = this.props;
        const orderId = match.params.workOrderId;

        workOrderActions.setSlideIndex(4, orderId);
        history.push(`/work-order-detail/${orderId}`);
    }

    jumpToJustAsk(e) {
        e.preventDefault();
        const { workOrderActions, history, match } = this.props;
        const orderId = match.params.workOrderId;

        workOrderActions.setSlideIndex(5, orderId);
        history.push(`/work-order-detail/${orderId}`);
    }

    render() {

        const {
            workOrder,
            match,
            workOrderActions,
            user,
            sqcActions,
            chargeActions
        } = this.props;
        const orderId = match.params.workOrderId;

        if (!workOrder) {
            return null;
        }
        const orderDetail = workOrder.getIn(['workOrderDetails', orderId]);

        if (!orderDetail) {
            return null;
        }

        const schedulingSystemDetails = orderDetail.getIn(['schedulingSystemDetails', 'details']);

        if (!schedulingSystemDetails) {
            return null;
        }

        const customerDetails = orderDetail.getIn(['customerDetails', 'details']);
        const justAskDetails = orderDetail.getIn(['justAskDetails']);
        const charges = orderDetail.getIn(['charges']);
        const schedulingSystemDetail = orderDetail.getIn(['schedulingSystemDetails', 'details']);
        const orderCloseDetails = orderDetail.getIn(['orderClose', 'details']);
        const sqcResults = orderDetail.getIn(['sqcResults']);
        const closeCodes = orderDetail.getIn(['closeCodes', 'details']);
        const backToOrderLink = (<Link to={`/work-order-detail/${orderId}`} />);
        const orderStatus = orderDetail.getIn(['orderStatus']);
        const equipmentDetails = orderDetail.getIn(['equipmentDetails', 'details']);
        const equipmentDetailsComplete = orderDetail.getIn(['equipmentDetails']);
        const leftHardCopy = orderDetail.getIn(['orderClose', 'details', 'termsAndConditions', 'hardCopyLeft']);
        const techId = schedulingSystemDetail.getIn(['technicianId']);
        const packageDetails = orderDetail.getIn(['packageDetails', 'details']);

        const returnIcon = ((
            <FontIcon className="material-icons">open_in_browser</FontIcon>
        ));

        const returnButton = (<FlatButton
            icon={returnIcon}
            label="Return"
            fullWidth
            containerElement={backToOrderLink} />);

        const workOrderHeader = (<WorkOrderHeader
            schedulingSystemDetail={schedulingSystemDetail}
            orderStatus={orderDetail.getIn(['orderStatus'])}
            orderId={orderId} />);

        const isInFinalState = isFinalState(orderStatus);

        if (orderId && orderStatus && isInFinalState) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Order is Closed.</h5>
                    {returnButton}
                </div>
            );
        }

        if (orderId && orderStatus && isClosingOrderState(orderStatus)) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Order is being processed. Please check the final state on the Route screen.</h5>
                    {returnButton}
                </div>
            );
        }

        if (orderId && orderStatus && isFailedState(orderStatus)) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Order close failed. Please contact dispatch.</h5>
                    {returnButton}
                </div>
            );
        }

        if (orderStatus && orderStatus.get('loading')) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Checking Order Status.</h5>
                    {returnButton}
                </div>
            );
        }

        if (orderStatus && orderStatus.get('loading')) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Checking Order Status.</h5>
                    {returnButton}
                </div>
            );
        }

        if (!orderId || !orderStatus || !isInProgressState(orderStatus)) {
            return (
                <div>
                    {workOrderHeader}
                    <h5>Order must be in service to close.</h5>
                    {returnButton}
                </div>
            );
        }

        if (orderDetail) {
            return (
                <div id="close_step_container">
                    <Loading
                        isLoading={
                            orderDetail.getIn(['orderClose', 'orderClosingStarted']) ||
                            orderDetail.getIn(['orderClose', 'closeOrderRequestAddStarted']) ||
                            orderDetail.getIn(['orderClose', 'loading']) ||
                            false}
                    />
                    {workOrderHeader}
                    <br />
                    <div className="row">
                        <div className="col s4">
                            <FlatButton
                                style={{
                                    textDecoration: 'underline'
                                }}
                                label="Just Ask"
                                onTouchTap={this.jumpToJustAsk} />
                        </div>
                        <div
                            className="col s8"
                            style={{
                                paddingTop: '8px'
                            }}>
                            <JustAskSummary
                                style={{
                                    display: 'inline-block'
                                }}
                                justAskDetails={justAskDetails} />
                        </div>
                    </div>
                    <CloseSteps
                        orderStatus={orderStatus}
                        closeCodes={closeCodes}
                        schedulingSystemDetail={schedulingSystemDetail}
                        sqcActions={sqcActions}
                        equipmentDetails={equipmentDetails}
                        user={user}
                        chargeActions={chargeActions}
                        charges={charges}
                        accountNumber={customerDetails ? customerDetails.get('accountNumber') : null}
                        orderId={orderId}
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        sqcResults={sqcResults}
                        customerDetail={customerDetails}
                        leftHardCopy={leftHardCopy}
                        techId={techId}
                        packageDetails={packageDetails}
                        equipmentDetailsComplete={equipmentDetailsComplete}
                    />
                    <Footer />
                </div>
            );
        }
        else {
            return (
                <div>There is no detail</div>
            );
        }
    }
}

CloseOrderPage.propTypes = {
    workOrderActions: PropTypes.object.isRequired,
    sqcActions: PropTypes.object.isRequired,
    history: PropTypes.object,
    workOrder: PropTypes.object.isRequired,
    match: PropTypes.object,
    user: PropTypes.object,
    chargeActions: PropTypes.object

};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        site: state.get('site'),
        user: state.get('user')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        siteActions: bindActionCreators(siteActions, dispatch),
        sqcActions: bindActionCreators(sqcActions, dispatch),
        chargeActions: bindActionCreators(chargeActions, dispatch),
        justAskActions: bindActionCreators(justAskActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CloseOrderPage));



// WEBPACK FOOTER //
// ./src/containers/pages/CloseOrderPage.js